import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AllRoutes from "./router/AllRoutes";
import ScrollToTop from "./components/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";
import "photoswipe/dist/photoswipe.css";
import "bootstrap/dist/js/bootstrap";
import undercontruction from '../src/assets/UnderConstruction.png'
const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);
  window.addEventListener("load", AOS.refresh);

  return (
    <>
    
        <Helmet>
  <title>Raiden Studios | Blockchain, DeFi, Gaming & VR Experts</title>
  <meta name="description" content="Raiden Studios is a leading mobile game, AR/VR, and custom app development company based in Coimbatore. Bring your ideas to life." />
  <meta name="keywords" content="Raiden Studios, game development, mobile apps, AR, VR, Coimbatore software company, app development" />
  

  <meta property="og:title" content="Raiden Studios | Game & App Development Company" />
  <meta property="og:description" content="We specialize in mobile games, AR/VR, and custom software solutions. Contact Raiden Studios today!" />
  <meta property="og:image" content="https://raiden.studio/public/Raiden_logo.svg" />
  <meta property="og:url" content="https://raiden.studio/" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Raiden Studios" />


      </Helmet>
   

      <ScrollToTop />
  

      <AllRoutes />
    </>
  );
};

export default App;
